(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sectionrose"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('uw-banner-slider-v2')) {
    customElements.define('uw-banner-slider-v2', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.uwbs__slides');
        this.slides = [...this.querySelectorAll('.uwbs__slide')];
        this.dots = [...this.querySelectorAll('[data-slide-to]')];
        this.pauseButton = this.querySelector('[data-pause]');
        this.index = 0;
        this.drag = null;
        this.hovered = false;
        this.editorSelected = false;
        this.suppressClickUntil = 0;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
        if (!this.slides.length) return;
        this.resizeObserver = new ResizeObserver(() => this.updateHeight());
        this.slides.forEach(slide => this.resizeObserver.observe(slide));
        this.querySelectorAll('.uwbs__arrow, .uwbs__controls').forEach(el => { el.hidden = this.slides.length < 2; });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.matches('[data-pause]')) this.paused = !this.paused;
          else if (button.matches('[data-next]')) this.go(this.index + 1);
          else if (button.matches('[data-previous]')) this.go(this.index - 1);
          else if (button.matches('[data-slide-to]')) this.go(Number(button.dataset.slideTo));
          this.sync();
        }, { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        // Native horizontal scrolling supports touch swipes and trackpad gestures.
        this.track.addEventListener('scroll', () => {
          clearInterval(this.timer);
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            if (this.drag) return;
            const width = this.track.clientWidth;
            if (width) this.select(Math.round(this.track.scrollLeft / width));
            this.sync();
          }, 140);
        }, { passive: true, signal });
        this.track.addEventListener('pointerdown', event => {
          clearInterval(this.timer);
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (event.target.closest('button, input, select, textarea')) return;
          this.drag = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft, moved: false };
        }, { signal });
        window.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const dx = event.clientX - this.drag.x;
          if (Math.abs(dx) > 8) this.drag.moved = true;
          if (!this.drag.moved) return;
          this.track.setAttribute('data-dragging', '');
          this.track.scrollLeft = this.drag.left - dx;
          event.preventDefault();
        }, { signal });
        const endDrag = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const drag = this.drag;
          this.drag = null;
          this.track.removeAttribute('data-dragging');
          if (drag.moved) {
            this.suppressClickUntil = Date.now() + 500;
            const dx = event.clientX - drag.x;
            this.go(this.index + (Math.abs(dx) >= 40 ? (dx < 0 ? 1 : -1) : 0));
          }
          this.sync();
        };
        window.addEventListener('pointerup', endDrag, { signal });
        window.addEventListener('pointercancel', endDrag, { signal });
        this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.track.addEventListener('click', event => {
          if (Date.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal });
        this.addEventListener('mouseenter', event => {
          if (event.sourceCapabilities?.firesTouchEvents) return;
          this.hovered = true;
          this.sync();
        }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, { signal });
        this.addEventListener('focusin', event => {
          if (!event.target.closest('[data-pause]')) this.paused = true;
          this.sync();
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorSelected = true;
          this.go(index, false);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.sync(); }, { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.sync();
        }, { signal });
        window.addEventListener('resize', () => this.go(this.index, false), { signal });
        this.go(0, false);
      }
      updateHeight() {
        const slide = this.slides[this.index];
        if (slide) this.track.style.height = `${slide.getBoundingClientRect().height}px`;
      }
      select(index) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.slides.forEach((slide, i) => { slide.inert = i !== this.index; });
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.updateHeight();
      }
      go(index, smooth = true) {
        const target = (index + this.slides.length) % this.slides.length;
        this.select(target);
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: smooth && !this.motion.matches ? 'smooth' : 'instant' });
        this.sync();
      }
      sync() {
        clearInterval(this.timer);
        this.track.setAttribute('aria-live', this.paused ? 'polite' : 'off');
        if (this.pauseButton) {
          this.pauseButton.dataset.paused = String(this.paused);
          this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
          this.pauseButton.removeAttribute('title');
        }
        if (this.slides.length < 2 || this.paused || this.hovered || this.editorSelected || this.drag || document.hidden) return;
        this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.speed) || 5000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.scrollTimer);
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
